import { configureStore } from "@reduxjs/toolkit";
import sidebarReducer from "../feature/sidebar/sidebarSlice";
import loginReducer from "../feature/login/loginSlice";
import userReducers from "../feature/users/userSlice";
import orderReducers from "../feature/orders/orderSlice";
import driverReducers from "../feature/drivers/driverSlice";
import deliveryModesReducers from "../feature/deliveryModes/deliveryModesSlice";
import transactionReducers from "../feature/transaction/transactionSlice";
import paymentReducers from "../feature/payment/paymentSlice";
import supportReducers from "../feature/support/supportSlice";
import modeReducer from "../feature/modeSlice";

export const store = configureStore({
  reducer: {
    login: loginReducer,
    sidebar: sidebarReducer,
    users: userReducers,
    orders: orderReducers,
    mode: modeReducer,
    drivers: driverReducers,
    deliveryModes: deliveryModesReducers,
    payments: paymentReducers,
    transactions: transactionReducers,
    supports: supportReducers,
  },
});
